// extracted by mini-css-extract-plugin
export default {"noticeList":"notice_list_noticeList__nZVMR","Mui-focused":"notice_list_Mui-focused__0vqwD","label":"notice_list_label__Qv6y6"};